<template>
  <v-dialog
		v-model="dialog"
		persistent
		width="880"
	>
		<v-card>
			<!-- Cabecera del formulario -->
			<v-card-title class="headline">
				<v-flex xs9>
					<v-icon>done</v-icon> Aprobar permiso 
				</v-flex>
				<v-spacer></v-spacer>
				<v-btn icon @click.native="close()">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>

			<!-- Cuerpo del formulario -->
			<v-form
				@submit.prevent="save"
				v-model="valid"
				ref="form"
				lazy-validation
				>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout row wrap>
							<v-flex xs12>
								<h3><strong>Número:</strong>   {{form.id }}</h3>
							</v-flex>
								<v-flex xs12>
								<h3><strong>Funcionario:</strong>   {{form.nombres }}</h3>
							</v-flex>
								<v-flex xs12>
								<h3><strong>Tipo de papeleta:</strong>{{ form.esAutoridad ? "FORMULARIO DE ASISTENCIA AUTORIDADES" : "CONTROL DE ASISTENCIA MANUAL" }} </h3>
							</v-flex>	
						</v-layout>

					</v-container>
					<v-container>
        				<h3 v-if="permiso_detalles!=null "><strong>Detalles de papeleta</strong></h3>
          
        					<v-data-table
									:items="permiso_detalles"
									class="elevation-1"
									hide-actions
									:headers="headers"
									
									>
							<template v-slot:items="props">
							<td class="text-xs-center"
							   >{{ props.item.fecha}}
							</td>
							<td class="text-xs-center">
								{{ props.item.ingreso_am}}
							</td>
								
							<td class="text-xs-center">{{ props.item.salida_am }}</td>
							<td class="text-xs-center">{{ props.item.ingreso_pm }}</td>
							<td class="text-xs-center">{{ props.item.salida_pm }}</td> 
						    <td class="text-xs-center">{{ props.item.estado_detalle }}</td> 
							
					</template>
				</v-data-table>
          </v-container>
		  	<v-container>
        				<h3 v-if="permiso_detalles!=null "><strong>Seguimiento de la papeleta</strong></h3>
          
        					<v-data-table
									:items="seguimiento_detalles"
									class="elevation-1"
									hide-actions
									:headers="headers2"
									
									>
							<template v-slot:items="props">	
							<td class="text-xs-center">{{ props.item.fecha_registro }}</td>
							<td class="text-xs-center">{{ props.item.estado }}</td>
							<td class="text-xs-center">{{ props.item.usuario }}</td> 
		
					</template>
				</v-data-table>
          </v-container>
				
				</v-card-text>
				  <v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="secundary" @click.prevent="close()" :loading="loading"
					><v-icon>check</v-icon>
					Cancelar
					</v-btn>
					<v-btn
					color="success"
					@click.prevent="apruebaRechazaPermiso()"
					:loading="loading"
					><v-icon>check</v-icon>
					Aprobar
					</v-btn>
				
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
import validate from '@/common/mixins/validate'; // Importación de mixin de validaciones

export default {
	// Definición de mixins importados
	mixins: [validate],
	// Variables iniciales
	data () {
		return {
			dialog: false,
			form: {},
			valid: false,
			loading: false,
			permiso_detalles:[],
			seguimiento_detalles:[],
			 headers: [
				{
				text: "Fecha",
				sortable: false
				},
				{
				text: "Hora ingreso mañana",
				sortable: false
				},
				{
				text: "Hora salida mañana",
				sortable: false
				},
			{
				text: "Hora ingreso tarde",
				sortable: false
				},
				{
				text: "Hora salida tarde",
				sortable: false
				},
				{
				text: "Estado",
				sortable: false
				},
				
			],
				 headers2: [
				{
				text: "Fecha registro",
				sortable: false
				},
				{
				text: "Estado",
				sortable: false
				},
				{
				text: "Usuario",
				sortable: false
				},
				],
		}
	},
	mounted () {
		this.$bus.$on('openDialogAprobarAsistencia', item => {
			this.form = item
			 this.cargarDetallesRegistro(this.form.id)
			  this.cargarSeguimiento(this.form.id)
			this.dialog = true
		})
	},
	methods: {
		close() {
			this.form = {},
			this.loading = false
			this.valid = false
			this.$bus.$emit('closeDialog')
			this.dialog = false
		},
		 async apruebaRechazaPermiso(){
			const user = this.$storage.get("user");
			let fecha_actual = this.$moment(new Date()).format("YYYY/MM/DD");
		    let respuesta = "";
			 try {
			
							respuesta = await this.$service.graphql({
							query: `
								query{
								runQuery(consulta:"select control.fn_anula_aprueba_asistencia_manual(${parseInt(this.form.id)},7,${user.id},'${fecha_actual}')"){
									respuesta
								}
								}
							`
							});
						
							let resp=respuesta.runQuery.respuesta[0].fn_anula_aprueba_asistencia_manual 
							let resps2 = resp.split("|");
						
							let correcto = resps2[0];
							if (correcto == "1") {
										this.$confirm("El permiso fue aprobado exitosamente", () => {
											this.close()
										//document.location.reload() 
										});
										}else{
								this.$message.warning(resps2[1])}
						
						} catch (error) {
							console.log(error);
						}
		 },
		async cargarDetallesRegistro(id_cabecera){
			try {
				let respuesta = await this.$service.graphql({
					query: `
					query{
						vAsistenciaManualDetalles(id_cabecera:${parseInt(id_cabecera)}){
						rows{
							id_persona
							ingreso_am
							ingreso_pm
							id_estado_detalle
							id_estado_cabecera
							fecha
							salida_am
							salida_pm
							ruta
							estado_detalle
							estado_cabecera
						id_detalle
							id_cabecera
							autoridad
						}
						}
					}
						`,
					});
         
         this.permiso_detalles = respuesta.vAsistenciaManualDetalles.rows
       } catch (error) {
         console.log(error)
       }
     },
		async cargarSeguimiento(id_cabecera){
			try {
					let respuesta = await this.$service.graphql({
						query: `
						query{
							vSeguimientoMarcadoManuals(id_cabecera:${parseInt(id_cabecera)}){
								rows{
								id_cabecera
								id_detalle
								usuario
								fecha_registro
								estado
								_user_created
								
								}
							}
						}
							`,
					});
			
			this.seguimiento_detalles = respuesta.vSeguimientoMarcadoManuals.rows
			
		} catch (error) {
			console.log(error)
		}	

		},
		async save () {
		
		}
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/registro_manual_asistencia/dialogs/AprobarAsistencia.vue